import BaseService from '../../base/base_service';
import _ from '../../utils/underscore';
import IOpenSessions, {IOpenSessionDetails, OpenSessionsServiceInitParams} from './open_sessions_service_interface';

class OpenSessionsService extends BaseService implements IOpenSessions{

  static CLASS: string = 'OpenSessionsService';
  private _initParams: OpenSessionsServiceInitParams = null;

  init(params: OpenSessionsServiceInitParams) {
    super.init(params);
    this._setInitParams(params);
  }

  private _setInitParams(params: OpenSessionsServiceInitParams): void {
    this._initParams = {
      uri: params.uri,
      showBtnReminder: !_.isBoolean(params.showBtnReminder) ? true : params.showBtnReminder
    };
  }

  public getOpenSession(): any[] {
    if (this._isAuthorized()) {
      return this.serviceFactory.oAuth2Service().extractTokenProperty('openSessions');
    }

    this.logger.debug('The user is not authorized so getting empty open session => ', []);
    return [];
  }

  public getRealGameOpenSessions(gameType: number): Promise<any> {
    const uri = this._initParams.uri + '/getOpenSessions';
    return this.serviceFactory.http2Service().post(uri, {
      gameTypes: [gameType],
      includeFreePlaySessions: false
    })
      .then(data => (data as any).sessionDetails);
  }

    public getAllGamesOpenSessions(): Promise<IOpenSessionDetails[]> {
        const uri = this._initParams.uri + '/getOpenSessions';
        return this.serviceFactory.http2Service().post(uri, {
            includeFreePlaySessions: false
        })
            .then(data => (data as any).sessionDetails);
    }

  public getPlayerOpenSessionsBalance(): Promise<number> {
    return this.getPlayerRealMoneyOpenSessions().then((openSessions)=> {
      let sum = 0;
      for(let index=0, openSessionsLength = openSessions.length; index < openSessionsLength; index++) {
        const credit = openSessions[index].Credit;
        if(!_.isNullOrUndefined(credit)){
          sum += Number(credit);
        }
      }

      return sum;
    });
  }

  public getPlayerRealMoneyOpenSessions(): Promise<any> {
    const uri = this._initParams.uri + '/getOpenSessions';
    return this.serviceFactory.http2Service().post(uri, {
      includeFreePlaySessions: false
    })
      .then(data => (data as any).sessionDetails);
  }

  private _filterOpenSessions(openSessions: any): Promise<any[]> {
    return this._filterOpenSessionsByRestrictions(this._filterOpenSessionsByProductPackage(openSessions));
  }

  private _filterOpenSessionsByProductPackage(openSessions: any[]): any[]{
    openSessions = openSessions || [];
    const productPackageList = this.serviceFactory.skinService().getProductPackageActiveGroup();
    return openSessions.filter(openSession => {
      return -1 !== productPackageList.indexOf(openSession.ProductPackage);
    });
  }

  private _filterOpenSessionsByRestrictions(openSessions: any[]): Promise<any> {
    const gameTypes = openSessions.map(openSession => openSession.GameTypeID);
    return this.serviceFactory.gamesInformationService().getGamesInfo(gameTypes)
      .then(gamesInfo => {
        const filteredOpenSessions = [];
        openSessions.forEach(openSession => {
          if (gamesInfo[openSession.GameTypeID]) {
            filteredOpenSessions.push(openSession);
          }
        });
        return filteredOpenSessions;
      });
  }

  private _isAuthorized(): boolean {
    return this.serviceFactory.oAuth2Service().isAuthorized();
  }
}

export default OpenSessionsService;